import StageTwo from "../Views/StageTwo";

const routes = [
  {
    path: "/stage-two",
    element: <StageTwo />,
    title: "Stage Two",
  },
];

export default routes;
